export default "__VITE_ASSET__92517941__"